module.exports = __webpack_public_path__ + "static/media/2DGACM3.a5d540de.jpg";